<script setup lang="ts">
import { computed } from "vue";
import { parseRichText } from "@/utils/richText";

const props = defineProps<{ text?: string | null }>();

const lines = computed(() => parseRichText(props.text));
</script>

<template>
  <template v-for="(line, i) in lines" :key="i">
    <br v-if="i > 0" /><span
      v-for="(run, j) in line"
      :key="j"
      :class="{ 'font-bold': run.bold, italic: run.italic }"
      >{{ run.text }}</span
    >
  </template>
</template>
